import React from "react";
import PropTypes from "prop-types";
import ShippingDate from "./../ShippingDate";

const ShippingOptions = (props) => (
  <div className="shipping-options">
    <h3>{props.header}</h3>
    <ShippingDate
      isLoading={props.isLoading}
      shippingDates={props.shippingDates}
      isTracked={props.isTracked}
      countryModel={props.countryModel}
      description={props.description}
    />
  </div>
);

ShippingOptions.propTypes = {
  header: PropTypes.string.isRequired,
  description: PropTypes.string,
  countryModel: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  shippingDates: PropTypes.array,
  isTracked: PropTypes.bool,
};

export default ShippingOptions;
